






















import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import DisplayNameUniqueQuery from '~/queries/displayNameUnique.gql';

@Component
export default class DisplayNameInput extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(String) readonly hint!: string;
  @Prop({ type: String, default: '0' }) readonly tabindex!: string;

  checkingDisplayNameAvailability = false;
  displayNameErrors: any[] = [];
  displayNameValid = false;
  timeout: any = null;

  @Emit('input-focused')
  handleFocus() {
    return true;
  }

  @Watch('value')
  validateDisplayName(input: string) {
    this.displayNameErrors = [];
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (input === '') {
      this.displayNameErrors = [
        this.$t('common.notifications.requiredField') as string,
      ];
      this.displayNameValid = false;
    } else {
      this.timeout = setTimeout(async () => {
        this.checkingDisplayNameAvailability = true;

        const { data } = await this.$apollo.query({
          query: DisplayNameUniqueQuery,
          variables: { displayName: input },
        });

        this.checkingDisplayNameAvailability = false;

        if (data.displayNameUnique) {
          const { displayName, unique } = data.displayNameUnique;

          if (!unique && displayName === this.value) {
            this.displayNameErrors = [
              this.$t(
                'components.settings.displayNameInput.nameNotAvailable',
              ) as string,
            ];
            this.displayNameValid = false;
          } else {
            this.displayNameValid = true;
            this.displayNameErrors = [];
          }
        }
      }, 1000);
    }
  }

  @Watch('displayNameValid')
  emitValidity(valid: boolean) {
    this.$emit('validity-change', valid);
  }
}
